import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'

type TSkeletonCards = {
    count?: number
}
const SkeletonCards = ({ count = 10 } : TSkeletonCards) => {
    return (
        <>
            {[...Array(count)].map((_, i) => (
                <div className="moduleList_card" key={i}>
                    <div className="moduleList_cardBody">
                        {[...Array(4)].map((__, j) => (
                            <div className="moduleList_cardRow" key={j}>
                                <Skeleton height={12} width={80} />
                                <Skeleton height={16} />
                            </div>
                        ))}
                    </div>
                </div>
            ))}
        </>
    )
}

export default SkeletonCards